import { render, staticRenderFns } from "./carrier.container.vue?vue&type=template&id=78feb904&scoped=true&lang=pug"
import script from "./carrier.container.vue?vue&type=script&lang=ts"
export * from "./carrier.container.vue?vue&type=script&lang=ts"
import style0 from "./carrier.container.vue?vue&type=style&index=0&id=78feb904&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "78feb904",
  null
  
)

export default component.exports